import {SmtpCredentialsResponseBody, OAuthEmailCredentialsResponseBody} from '@dms/api/core';

export const isOAuthCredential = (
  credential: SmtpCredentialsResponseBody | OAuthEmailCredentialsResponseBody
): credential is OAuthEmailCredentialsResponseBody => credential.type === 'oauth';
